import { useSuspenseGqlQuery } from "@/lib/GraphQLCodegen/fetcher";
import { relocationRecordQuery } from "@/app/Relocations/GraphQL/relocationRecordQuery";
import { redirect } from "@tanstack/react-router";

export function useRelocation(id: string) {
  const { data } = useSuspenseGqlQuery(relocationRecordQuery, {
    id,
  });

  const relocation = data.relocation;

  if (!relocation) {
    throw redirect({
      from: "/$tenant/$orgId/supplier/{-$supplierId}",
      to: "/$tenant/$orgId/supplier/{-$supplierId}/relocations/not-found",
      params: (prev) => prev,
    });
  }

  return relocation;
}
